export default __webpack_public_path__ + "static/media/my-list-ribbon-remove.52900892.svg";